import {
	Button,
	Grid,
	Typography,
	makeStyles,
} from "@material-ui/core";
import decode from "jwt-decode";
import { useState } from "react";
import Dropzones from "../../../components/molecules/Dropzone";

const useStyles = makeStyles((theme) => ({
	textarea: {
		width: "100%",
		// width: "21.6rem",
		height: "10rem",
		resize: "none",
		border: "1px solid",
		padding: "0.5rem",
		borderRadius: "10px",
		// [theme.breakpoints.only("lg")]: {
		// 	width: "15.8rem",
		// },
		// [theme.breakpoints.only("sm")]: {
		// 	width: "45.6rem",
		// },
		[theme.breakpoints.only("xs")]: {
			height: "5rem",
		},
	},
	button: {
		marginTop: theme.spacing(2),
	},
}));

const AddNotes = (props) => {
	const decoded = decode(localStorage.token);
	const { addComment, fetchAPI, issues } = props;
	const classes = useStyles();

	const [selectFile, setSelectFile] = useState({ file: [] });
	const [state, setState] = useState({
		loading: false,
		error: "",
		comment: {
			name: decoded.nama_user,
			message: "",
		},
	});

	const handleFieldChange = (event) => {
		const { value, name } = event.target;
		setState({
			...state,
			comment: {
				...state?.comment,
				[name]: value,
			},
		});
	};
	const reset = () => {
		setState({
			loading: false,
			comment: { ...state?.comment, message: "" },
		});
		setSelectFile({ file: [] });
	};

	const isFormValid = () => {
		return state?.comment?.name !== "" && state?.comment?.message !== "";
	};

	const renderError = () => {
		return state.error ? (
			<div className="alert alert-danger">{state.error}</div>
		) : null;
	};

	const onSubmit = async (e) => {
		// prevent default form submission
		e.preventDefault();
		if (!isFormValid()) {
			setState({ error: "All fields are required." });
			return;
		}

		const formData = new FormData();
		const dataFetch = {
			...state,
			idticket: issues?.idticket,
			idlayanan: issues?.idlayanan,
			idstatus: issues?.idstatus,
			name: state?.comment?.name,
			message: state?.comment?.message,
		};

		Object.values(selectFile).forEach((file) => {
			formData.append("id", dataFetch.idticket);
			formData.append("idlayanan", dataFetch.idlayanan);
			formData.append("idstatus", dataFetch.idstatus);
			formData.append("name", dataFetch.name);
			formData.append("message", dataFetch.message);
			if (file) {
				formData.append("images", file);
			} else {
				formData.append("images", []);
			}
			return selectFile;
		});

		let result = await fetchAPI("addForm", formData);
		setState({ loading: true, comment: { ...state?.comment } });
		if (result?.status === "success") {
			addComment(state?.comment, issues);
			reset();
		}
		return result;
	};
	return (
		<div>
			<form onSubmit={onSubmit}>
				<Typography variant="h6">Comment for issue</Typography>
				{/* <div class> */}
				<textarea
					className={classes.textarea}
					name="message"
					onChange={handleFieldChange}
					value={state?.comment?.message || ""}
					placeholder="Your Comment"
					aria-label="maximum height"
				/>
				{/* </div> */}
				{/* <FormControl>
					<TextareaAutosize
						required
						className={classes.textarea}
						maxRows={5}
						minRows={5}
						name="message"
						onChange={handleFieldChange}
						value={state.comment.message}
						placeholder="Your Comment"
						aria-label="maximum height"
					/>
				</FormControl> */}
				<div
					style={{
						border: "2px dashed",
						borderColor: "#3f51b5", // primary color
						// maxWidth: "20rem",
						borderRadius: "15px",
						margin: "5px 0",
						// minHeight: "5vh",
					}}
				>
					<Dropzones state={selectFile} setState={setSelectFile} />
				</div>
				{renderError()}
				<Grid
					className="form-group"
					style={{
						display: "flex",
						justifyContent: "end",
						marginTop: "0.5rem",
					}}
				>
					<Button
						type="submit"
						// disabled={state.loading}
						variant="contained"
						color="primary"
					>
						Submit &#10148;
					</Button>
				</Grid>
			</form>
		</div>
	);
};

export default AddNotes;
